import { render, staticRenderFns } from "./loading-overlay.vue?vue&type=template&id=63dbc49e&scoped=true&"
import script from "./loading-overlay.ts?vue&type=script&lang=ts&"
export * from "./loading-overlay.ts?vue&type=script&lang=ts&"
import style0 from "./loading-overlay.scss?vue&type=style&index=0&id=63dbc49e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dbc49e",
  null
  
)

export default component.exports